import React, { useState } from "react";
import trans from "../../../../utils";
import Dropfile from "../../../Helpers/Dropzone/Dropzone";

export default function POIsAttachments({ addPOI, poiAttachments }) {
	return (
		<>
			<div className="d-flex align-items-center">
				<p className="fs-16 fw-500 brand-700 text-capitalize me-2">
					{trans("attachments")}
				</p>
				<p style={{ textTransform: "capitalize", color: "#42526E" }}>
					({trans("optional")})
				</p>
			</div>
			<Dropfile
				type="maintenance"
				addData={addPOI}
				EditableAttachments={poiAttachments}
				name="attachments"
			/>
		</>
	);
}
